import React from 'react';
import './styles/privacy-policy.css';

const sections = [
  {
    title: '1. Общие положения',
    content: [
      'Настоящая Политика конфиденциальности описывает, какие данные мы собираем, как мы их используем и защищаем при использовании видео-платформы с доступом к контенту по подписке.',
      'Приложение предназначено для пользователей старше 16 лет.',
    ],
  },
  {
    title: '2. Какие данные мы собираем',
    subsections: [
      {
        title: '2.1 Контактные данные',
        intro: 'Мы можем собирать:',
        bullets: [
          'номер телефона',
          'имя (если указано)',
          'адрес электронной почты (в будущем)',
          'другие контактные данные',
        ],
        outroTitle: 'Зачем:',
        outroBullets: [
          'регистрация и авторизация пользователя',
          'обеспечение работы аккаунта',
          'персонализация контента',
          'связь с пользователем',
          'отправка уведомлений',
          'маркетинг и информирование (при необходимости)',
        ],
      },
      {
        title: '2.2 Финансовая информация',
        content: [
          'Мы можем обрабатывать информацию о платежах (например, данные о подписке).',
        ],
        outroTitle: 'Зачем:',
        outroBullets: [
          'оформление и управление подпиской',
          'предоставление доступа к платному контенту',
          'персонализация услуг',
        ],
        note: 'Важно: фактическая обработка платежей может осуществляться сторонними платёжными системами (например, App Store / Google Play), и мы не храним полные данные банковских карт.',
      },
      {
        title: '2.3 Данные об активности',
        intro: 'Мы можем собирать:',
        bullets: [
          'историю поиска',
          'информацию о просмотренном контенте',
          'данные о покупках (подписках)',
        ],
        outroTitle: 'Зачем:',
        outroBullets: [
          'аналитика и улучшение приложения',
          'рекомендации контента',
          'персонализация пользовательского опыта',
        ],
      },
      {
        title: '2.4 Диагностические данные',
        intro: 'Мы можем собирать:',
        bullets: [
          'данные о сбоях и ошибках',
        ],
        outroTitle: 'Зачем:',
        outroBullets: [
          'обеспечение стабильной работы приложения',
          'исправление ошибок',
          'улучшение качества сервиса',
        ],
      },
    ],
  },
  {
    title: '3. Использование данных',
    intro: 'Мы используем данные для:',
    bullets: [
      'обеспечения работы приложения',
      'предоставления доступа к видео-контенту',
      'управления подпиской',
      'персонализации контента',
      'анализа и улучшения сервиса',
      'связи с пользователями',
      'обеспечения безопасности',
    ],
  },
  {
    title: '4. Передача данных третьим лицам',
    content: [
      'На данный момент мы не передаём данные сторонним сервисам.',
      'В будущем данные могут передаваться только в необходимом объёме.',
    ],
    bullets: [
      'сервисам аналитики',
      'платёжным системам',
      'сервисам авторизации (например, Google)',
    ],
  },
  {
    title: '5. Хранение и защита данных',
    content: [
      'Мы принимаем разумные технические и организационные меры для защиты данных пользователей от:',
    ],
    bullets: [
      'несанкционированного доступа',
      'утечки',
      'изменения или уничтожения',
    ],
    closing: 'Данные хранятся только столько времени, сколько необходимо для целей обработки.',
  },
  {
    title: '6. Права пользователей',
    content: [
      'Вы имеете право:',
    ],
    bullets: [
      'получить информацию о своих данных',
      'запросить исправление данных',
      'запросить удаление данных',
      'ограничить обработку данных',
    ],
    closing: 'Для этого свяжитесь с нами через контактные данные ниже.',
  },
  {
    title: '7. Cookies и технологии отслеживания',
    content: [
      'Приложение может использовать технологии, аналогичные cookies, для:',
    ],
    bullets: [
      'сохранения сессии пользователя',
      'улучшения работы приложения',
    ],
  },
  {
    title: '8. Изменения политики',
    content: [
      'Мы можем обновлять данную Политику конфиденциальности.',
      'Актуальная версия всегда будет доступна в приложении или на сайте.',
    ],
  },
];

const PrivacyPolicy = () => {
  return (
    <main className="privacy-page content">
      <section className="privacy-hero">
        <span className="privacy-kicker">Политика конфиденциальности</span>
        <h1>Политика конфиденциальности</h1>
        <p>Дата вступления в силу: 1 мая 2026 года</p>
        <p>
          Мы уважаем вашу конфиденциальность и стремимся защищать персональные данные
          пользователей нашего приложения.
        </p>
      </section>

      <section className="privacy-document">
        {sections.map((section) => (
          <article key={section.title} className="privacy-block">
            <h2>{section.title}</h2>

            {section.content?.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}

            {section.intro && <p>{section.intro}</p>}

            {section.bullets?.length > 0 && (
              <ul>
                {section.bullets.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            )}

            {section.subsections?.map((subsection) => (
              <div key={subsection.title} className="privacy-subsection">
                <h3>{subsection.title}</h3>

                {subsection.content?.map((paragraph) => (
                  <p key={paragraph}>{paragraph}</p>
                ))}

                {subsection.intro && <p>{subsection.intro}</p>}

                {subsection.bullets?.length > 0 && (
                  <ul>
                    {subsection.bullets.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                )}

                {subsection.outroTitle && <p>{subsection.outroTitle}</p>}

                {subsection.outroBullets?.length > 0 && (
                  <ul>
                    {subsection.outroBullets.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                )}

                {subsection.note && <div className="privacy-note">{subsection.note}</div>}
              </div>
            ))}

            {section.closing && <p>{section.closing}</p>}
          </article>
        ))}

        <article className="privacy-block privacy-contacts">
          <h2>9. Контакты</h2>
          <p>
            Если у вас есть вопросы по поводу данной политики, вы можете связаться с нами:
          </p>
          <a className="privacy-contact-link" href="mailto:contact@mtv-media.ru">
            contact@mtv-media.ru
          </a>
        </article>
      </section>
    </main>
  );
};

export default PrivacyPolicy;
